export default "__VITE_ASSET__DHx$pG5Y__"